import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetWithdrawalsAwaiting = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_AWAITING_WITHDRAWAL
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetWithdrawalsAwaitingAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetWithdrawalsAwaiting as SetGetWithdrawalsAwaiting
}